(function () {
  if (window.__bbSmoothAnchorsBound) return;
  window.__bbSmoothAnchorsBound = true;

  document.addEventListener('click', function (event) {
    if (
      event.defaultPrevented ||
      event.button > 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      !event.target.closest
    ) return;

    var trigger = event.target.closest('[data-bb-smooth-anchor]');
    if (!trigger) return;

    var hash = trigger.getAttribute('href');
    if (!hash || hash.charAt(0) !== '#' || hash.length < 2) return;

    var targetId;
    try {
      targetId = decodeURIComponent(hash.slice(1));
    } catch (_error) {
      return;
    }

    var target = document.getElementById(targetId);
    if (!target || typeof target.scrollIntoView !== 'function') return;

    event.preventDefault();
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'start',
    });

    if (window.history && typeof window.history.pushState === 'function') {
      window.history.pushState(null, '', hash);
    } else {
      window.location.hash = hash;
    }
  });
})();
